import { Button, Typography } from "@mui/material";
import { NextPage } from "next";
import { BoxColumn } from "../../components/common/Boxes";
import { withProtectedRoute, useAuth } from "../../context/Authentication";
import * as ethers from "ethers";
import { CHAIN_ID_MUMBAI, contractAddressMinterInitial } from "../../config";
import { MinterInitial } from "../../typechain/MinterInitial";
import { useEffect, useState } from "react";
import ABI_MinterInitial from "../../abis/ABI_MinterInitial.json";
import axios from "axios";
import { PageHead } from "../../components/PageHead";
import { useAlert } from "../../hooks/hooks";
import { Alert } from "../../components/Alert";

const MESSAGE_SUCCESS =
  "Successfully minted cards! Please wait a moment for the transaction to complete.";

const MESSAGE_ERROR = "Error minting cards";

const Mint: NextPage = () => {
  const { user, chainId } = useAuth();
  const [contractMinterInitial, setContractMinterInitial] =
    useState<MinterInitial>();

  const {
    messageError,
    setMessageError,
    messageSuccess,
    setMessageSuccess,
    unsetMessages
  } = useAlert();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const provider = new ethers.providers.Web3Provider(window.ethereum!);

      const contractMinterInitial = new ethers.Contract(
        contractAddressMinterInitial,
        ABI_MinterInitial,
        provider.getSigner()
      ) as MinterInitial;

      setContractMinterInitial(contractMinterInitial);
    }
  }, []);

  const mint = async () => {
    try {
      if (!contractMinterInitial) throw "contract not initialized";
      await contractMinterInitial.mintCards();
      setMessageSuccess(MESSAGE_SUCCESS);
    } catch (e) {
      console.error(e);
      setMessageError(MESSAGE_ERROR);
    }
  };

  const tokenFaucet = async () => {
    try {
      axios
        .post("https://api.faucet.matic.network/transferTokens", {
          address: user?.publicAddress || "",
          network: "mumbai",
          token: "maticToken"
        })
        .then(function (response) {
          setMessageSuccess(
            "Successfully requested mumbai MATIC. Please wait a moment for the transaction to complete."
          );
        })
        .catch(function (error) {
          console.error(error);
          setMessageError("Error requesting mumbai MATIC");
        });
    } catch (e) {
      console.error(e);
      setMessageError("Error requesting mumbai MATIC");
    }
  };

  return (
    <>
      <PageHead />
      <Alert
        onClose={unsetMessages}
        messageError={messageError}
        messageSuccess={messageSuccess}
      />
      <BoxColumn
        sx={{
          backgroundImage: "url(/apollo-free-mint.png)",
          height: "100%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
          alignItems: "center",
          justifyContent: "center",
          padding: "12px",
          position: "relative",
          overflow: "hidden"
        }}
      >
        <BoxColumn
          sx={{
            p: 2,
            alignItems: "center",
            overflowY: "auto",
            height: "100%"
          }}
        >
          <Typography variant="h4">Mint 12 cards for free!</Typography>

          <Button onClick={mint} sx={{ mt: 4 }}>
            Mint
          </Button>

          {chainId == CHAIN_ID_MUMBAI && (
            <Button onClick={tokenFaucet} sx={{ mt: 4 }}>
              Get Testnet MATIC Tokens for Gas!
            </Button>
          )}
        </BoxColumn>
      </BoxColumn>
    </>
  );
};

export default withProtectedRoute(Mint);
